import {ITheme} from 'contexts/ThemeContext';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  minSize,
} from 'rn-responsive-styles';

export default (props: ITheme) =>
  CreateResponsiveStyle(
    {
      container: {
        paddingBottom: 46,
        backgroundColor: props.colors.white,
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        paddingLeft: 15,
        paddingRight: 15,
        alignItems: 'center',
      },
    },
    {[minSize(DEVICE_SIZES.SMALL_DEVICE)]: {}},
  )();
